import {SESSION} from 'redux/actionTypes';
import defaultState from 'redux/reducers/generic/defaultState';
import manipState from "./generic/manipState";


const initialState = {
	...defaultState,
	planner: {
		width: false,
		height: false
	},
	setup: {
		ratio: false,
		domino: {
			size: {
				width: 2.4,
				heightFallWall: 2.4,
				height: 4.8,
				thickness: 0.75
			}
		},
		backgroundColor: '#FF0000',
		marginHorizontal: 0.75,
		marginVertical: 0.75,
		type: 1
	},
	id: false,
	name: false,
	defaultGroup: false,
	fetching: false,
	loaded: false,
	error: {
		status: false,
		message: '',
	}
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case SESSION.UPDATE_NAME: {
			let {name} = action.payload;
			return {
				...state,
				name
			};
		}
		case SESSION.UPDATE_SETUP: {
			const {
				bgColor = false,
				marginV = false,
				marginH = false,
				width = false,
				height = false,
				thickness = false,
				type = false,
				heightFallWall = false
			} = action.payload;

			let setup = {...state.setup};
			if (bgColor) {
				setup.backgroundColor = bgColor;
			}
			if (marginV) {
				setup.marginVertical = marginV;
			}
			if (marginH) {
				setup.marginHorizontal = marginH;
			}
			if (width) {
				setup.domino.size.width = width;
			}

			if (heightFallWall) {
				setup.domino.size.heightFallWall = heightFallWall;
			}

			if (height) {
				setup.domino.size.height = height;
			}
			if (thickness) {
				setup.domino.size.thickness = thickness;
			}
			if (type) {
				setup.type = type;
			} else {
				setup.type = 1;
			}

			return {
				...state,
				setup
			};
		}
		case SESSION.GET: {
			let payload = action.payload;
			let setupServer = payload.setup;
			delete payload.setup;

			let newState = {
				...state,
				loaded: true,
				fetching: false,
				error: {
					status: false,
					message: '',
				}
			};
			let setup = {...state.setup};
			if (setupServer.backgroundColor) {
				setup.backgroundColor = setupServer.backgroundColor;
			}
			if (setupServer.marginVertical) {
				setup.marginVertical = setupServer.marginVertical;
			}
			if (setupServer.marginHorizontal) {
				setup.marginHorizontal = setupServer.marginHorizontal;
			}
			if (setupServer.width) {
				setup.domino.size.width = setupServer.width;
			}
			if (setupServer.height) {
				setup.domino.size.height = setupServer.height;
			}
			if (setupServer.thickness) {
				setup.domino.size.thickness = setupServer.thickness;
			}
			if (setupServer.heightFallWall) {
				setup.domino.size.heightFallWall = setupServer.heightFallWall;
			}
			if (setupServer.ratio) {
				setup.ratio = setupServer.ratio;
			}
			if (setupServer.type) {
				setup.type = setupServer.type;
			}

			let planner = {...state.planner};
			if (payload.planner.height) {
				planner.height = payload.planner.height;
			}
			if (payload.planner.width) {
				planner.width = payload.planner.width;
			}

			newState.setup = setup;
			newState.planner = planner;

			if (payload.session && payload.session.id) {
				newState.id = payload.session.id;
			}

			if (payload.session && payload.session.name) {
				newState.name = payload.session.name;
			}

			if (payload.defaultGroup) {
				newState.defaultGroup = payload.defaultGroup;
			}

			return newState;
		}
		case SESSION.FETCHING: {
			return {
				...state,
				fetching: true,
				loaded: false,
				error: {
					status: false,
					message: '',
				},
			};
		}
		case SESSION.ERROR: {
			const {message} = action.payload;
			return {
				...state,
				fetching: false,
				loaded: true,
				error: {
					status: true,
					message: message,
				},
			};
		}
	}
	return manipState(state, action, 'SESSION');
};

export default reducer;
